<script>
	export let alternating = null
</script>

<div class="my-16 grid grid-flow-dense grid-cols-12 gap-4 sm:grid-flow-row md:gap-12">
	<div class="col-span-12 sm:col-span-5 {alternating ? 'sm:order-2' : ''}">
		<div class="rounded-lg border border-neutral-300 text-center md:p-4">
			<slot name="media">
				<img
					src="/images/fotovoltaika/Battery_HV9637.webp"
					alt="Baterie HV9637"
					class="inline-block"
				/>
			</slot>
		</div>
	</div>
	<div class="col-span-12 sm:col-span-7 {alternating ? 'md:order-1' : ''}">
		<slot>[missing content]</slot>
	</div>
</div>
